import axios from '@/common/axios'
// oss-cn-zhangjiakou
const  upload = async (item,ossInfo,timeout=1000*6*1000) => {
  const host = `https://${ossInfo.bucket}.${ossInfo.point}.aliyuncs.com`;
//   const host = `https://files.oss.imedunion.com`;
  let url = `${host}`;
  let headers = {
    timeout
  }
  return new Promise((resolve)=>{
      let data = new FormData()
      data.append("key",item.fileName);
      data.append("OSSAccessKeyId",ossInfo.access_key);
      data.append("policy",ossInfo.policy);
      data.append("Signature",ossInfo.signature);
      data.append("file",item.file);
      axios.post(url,data,headers).then(()=>{
        resolve({status:true,url:`https://files.oss.medflying.com/${item.fileName}`})
      }).catch((err)=>{
        console.error(err)
        resolve({status:false,url:`https://files.oss.medflying.com/${item.fileName}`})
      })
  })
}


export default {
  upload
}